<template>
  <div class="component-box">
    <div class="dialog-box">
      <div class="report-code-box">
        <div class="report-code-bg">
          <img src="../../assets/images/annual-report/2024-code.png" alt="" />
        </div>
        <p>扫码查看报告</p>
      </div>
      <img
        src="../../assets/images/annual-report/dialog-close.png"
        alt=""
        class="close-btn"
        @click="closrDialog()"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebAnnualReportDialog",

  data() {
    return {};
  },

  mounted() {},

  methods: {
    closrDialog() {
      // 关闭弹窗时 将当前用户的id存一下
      const key = "shopIsShow-" + this.$store.state.user.userInfo.userId;
      localStorage.setItem(key, "true");
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.component-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background: rgba($color: #000000, $alpha: 0.6);
  .dialog-box {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 370px;
    background: url(../../assets/images/annual-report/2024-dialog-bg.png)
      no-repeat;
    background-size: 100% 100%;
    .report-code-box {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .report-code-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 90px;
        border-radius: 10px;
        border: 1px solid #333;
        background: #fff;
        & > img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
      & > p {
        margin-top: 7px;
        color: #333;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px; /* 100% */
      }
    }
    .close-btn {
      position: absolute;
      top: 0;
      right: -55px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
}
</style>
